module.exports = __webpack_public_path__ + "staticcomp/img/cover.0f030ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/1/cover.jpg
// module id = YBXA
// module chunks = 39